import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PostCard from './PostCard';

const PostCardGroupWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  position: relative;
  @media screen and (min-width: 900px) {
    flex-wrap: wrap;
    padding: 2rem 0;
  }
  @media screen and (max-width: 600px) {
    flex-wrap: wrap;
  }
`;

const PostCardGroup = ({ posts, topBorder }) => (
  <PostCardGroupWrapper topBorder={topBorder}>
    {posts && posts.map(post => <PostCard key={post.node.id} data={post} />)}
  </PostCardGroupWrapper>
);

PostCardGroup.propTypes = {
  posts: PropTypes.array.isRequired,
  topBorder: PropTypes.bool,
};

export default PostCardGroup;
